module.exports = __webpack_public_path__ + "img/comprehensive_child_monitoring.76753883.svg";